"use client";
import React from 'react';
import './ClaimOption.css';
import PropTypes from 'prop-types';
import { ReactComponent as CaminandoIcon } from '../../assets/img/Caminando.svg';
import { ReactComponent as EnMotoIcon } from '../../assets/img/EnMoto.svg';
import { ReactComponent as EnAutoIcon } from '../../assets/img/EnAuto.svg';
import { ReactComponent as EnCasaIcon } from '../../assets/img/EnCasa.svg';
import { ReactComponent as EnBiciIcon } from '../../assets/img/EnBicicleta.svg';


const ClaimOption = ({ type, title, selected, handleSelect }) => {
	const renderType = () => {

		switch (type) {
			case 0:
				return <CaminandoIcon />
			case 1:
				return <EnBiciIcon />
			case 2:
				return <EnAutoIcon />
			case 3:
				return <EnMotoIcon />
			case 4:
				return <EnCasaIcon />
			default:
				break;
		}
	}
	return (
		<div onClick={() => handleSelect(type)} className={`claim-option hover:bg-dark-grey cursor-pointer py-6 px-3 md:px-5 rounded-[14px] text-red font-semibold text-sm flex flex-1 flex-col justify-between transition items-center gap-4 h-40 ${selected && 'selected'}`}>
			<div className='flex w-full items-center m-auto justify-center'>
				{renderType()}
			</div>
			<div className='text-center mt-2'>{title}</div>
		</div>
	);
};

ClaimOption.propTypes = {
	type: PropTypes.number,
	title: PropTypes.string,
	selected: PropTypes.bool,
	handleSelect: PropTypes.func
};

export default ClaimOption;